import { type SxProps, Typography } from '@mui/material';

type SectionHeadingProps = {
  id: string;
  children: React.ReactNode;
  sx?: SxProps;
};

export const SectionHeading = ({ id, children, sx, ...props }: SectionHeadingProps) => {
  return (
    <Typography
      variant="textLargeBold"
      component="h2"
      id={id}
      sx={{ fontSize: { xs: '24px', md: '32px' }, ...sx }}
      {...props}
    >
      {children}
    </Typography>
  );
};
